import { render, staticRenderFns } from "./videoWritingIndex.vue?vue&type=template&id=4db1cd16&scoped=true&"
import script from "./videoWritingIndex.vue?vue&type=script&lang=js&"
export * from "./videoWritingIndex.vue?vue&type=script&lang=js&"
import style0 from "./videoWritingIndex.vue?vue&type=style&index=0&id=4db1cd16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db1cd16",
  null
  
)

export default component.exports